import React from "react";

interface Props {
    children: React.ReactNode;
}
const AppProviders: React.FC<Props> = ({ children }) => {
    return <>{children}</>;
};

export default AppProviders;
